export enum CertificateOrientation {
  Portrait = 1,
  Landscape = 2,
}